import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { ChapterLabel } from "@/components/Expertise";
import { useLanguage } from "@/i18n/LanguageContext";

export default function ZoneIntervention() {
  const { t } = useLanguage();

  return (
    <section id="zone" data-testid="zone-section" className="bg-paper py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <ChapterLabel num="04" title={t("zone.label")} />
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8">
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8 }}
              className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.05]"
            >
              {t("zone.titleA")}<br />
              <em className="text-brass not-italic">{t("zone.titleB")}</em>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.15 }}
              className="mt-8 max-w-xl text-base leading-relaxed text-ink/70"
            >
              {t("zone.p")}
            </motion.p>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-4 border-l border-ink/10 pl-8 space-y-5"
          >
            {t("zone.zones").map((z) => (
              <div key={z} className="flex items-center gap-3">
                <MapPin size={15} strokeWidth={1.5} className="text-brass shrink-0" />
                <span className="text-sm text-ink/80">{z}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
